import { ca } from '@cian/analytics';
import { ECadastralFieldsNames } from '../../types/reducers/rosreestrData';

export const trackInfoOpen = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'filling',
    action: 'kadastral_number',
    label: 'help',
  });
};

export const trackInvalidSymbolEntered = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'filling',
    action: 'kadastral_number',
    label: 'symbol_error',
  });
};

export const trackInvalidValueEntered = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'filling',
    action: 'kadastral_number',
    label: 'mask_error',
  });
};

export const trackValidValueEntered = (key: ECadastralFieldsNames) => {
  const label = key === ECadastralFieldsNames.BuildingCadastralNumber ? 'fill_house' : 'fill_land';

  ca('eventSite', {
    name: 'oldevent',
    category: 'filling',
    action: 'kadastral_number',
    label,
  });
};

export const trackCheckButtonClick = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'filling',
    action: 'kadastral_number',
    label: 'check_button',
  });
};

export const trackLandFieldSubmit = (isRequired: boolean, value: string) => {
  let label;

  if (isRequired && !value) {
    label = 'required_field_unfilled_land_kadastral';
  } else if (isRequired && value) {
    label = 'required_field_filled_land_kadastral';
  } else if (!isRequired && !value) {
    label = 'field_unfilled_land_kadastral';
  } else {
    label = 'field_filled_land_kadastral';
  }

  ca('eventSite', {
    name: 'oldevent',
    category: 'New_ad',
    action: 'required_kadastral',
    label,
  });
};

export const trackNoCadastralNumberButtonClick = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'New_ad',
    action: 'required_kadastral',
    label: 'without_land_kadastral',
  });
};

export const trackNoCadastralNumberReasonSubmit = (reason: string) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'New_ad',
    action: 'required_kadastral',
    label: 'without_land_kadastral_popup',
    products: [
      {
        extra: {
          no_kadastral_reason: reason,
        },
      },
    ],
  });
};

export const trackInformModalOpen = (siteType: string, formId: string) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'kadastral_number',
    action: 'click_sopr',
    label: 'show_information_example',
    page: {
      pageType: 'AddForm',
      siteType,
      extra: {
        form_id: formId,
      },
    },
  });
};
